export class BuyNowModel {
    public servicePlan: string;
    public mobile: string;
    public email: string;
    public fullname: string;
    public discountCode: string;
}
